(function () {
  function init(root) {
    if (!root || root.dataset.whCdInit === '1') return;
    root.dataset.whCdInit = '1';

    var track = root.querySelector('[data-wh-cd-track]');
    var dots = root.querySelectorAll('[data-wh-cd-dot]');
    var slides = root.querySelectorAll('[data-wh-cd-slide]');
    if (!track || !dots.length || !slides.length) return;

    function update() {
      var rect = track.getBoundingClientRect();
      var center = rect.left + rect.width / 2;
      var active = 0;
      var best = Infinity;
      slides.forEach(function (s, i) {
        var r = s.getBoundingClientRect();
        var c = r.left + r.width / 2;
        var dist = Math.abs(c - center);
        if (dist < best) { best = dist; active = i; }
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var slide = slides[i];
        if (!slide) return;
        var target = slide.offsetLeft - (track.clientWidth - slide.clientWidth) / 2;
        track.scrollTo({ left: target, behavior: 'smooth' });
      });
    });

    update();
  }

  function boot() {
    document.querySelectorAll('[data-wh-cd]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
